export enum EmployerFormFieldErrors {
  name = 'Please enter a valid name',
  type = 'Please choose the type',
}

export enum UserFormErrors {
  firstName = 'Please enter a valid first name',
  lastName = 'Please enter a valid last name',
  middleName = 'Please enter a valid middle name',
  email = 'Please provide a valid email address',
}

export enum ChangePasswordErrors {
  passwordRequired = 'Password is required',
  matchFormat = 'Please match the requested format',
  passwordsDontMatch = 'Passwords don’t match',
}

export enum IraAccountsErrors {
  type = 'Please choose a profile type',
  annualFee = 'Please enter a valid annual fee',
}

export enum CustodianTypeErrors {
  required = 'Please choose a custodian type',
}

export enum BusinessNameErrors {
  required = 'Please enter a valid business name',
}

export enum EtzFeeErrors {
  required = 'Please enter a valid ETZ fee',
  min = 'ETZ fee must be greater than or equal to 0.0005',
  max = 'ETZ fee must be less than or equal to 0.05',
}

export enum CustodyFeePercentageErrors {
  minMax = '% annual custody/maintenance fee must be between 0.01% and 10%',
  shouldEmpty = 'Custody/maintenance fee cannot be applied unless the next billing date is specified',
}

export enum CustodyFeeAbsoluteErrors {
  minMax = '$ annual custody/maintenance fee must be between $1 and $1000',
  shouldEmpty = 'Custody/maintenance fee cannot be applied unless the next billing date is specified',
}

export enum NextBillingDateErrors {
  format = 'Please enter a valid date',
  shouldEmpty = 'The next billing date should be empty if no custody/maintenance fee is specified',
}

export enum LoginFormErrors {
  usernameRequired = 'Username is required',
}

export enum AssignDepositFormFieldErrors {
  userProfileId = 'Please select a user from the list',
  contributionType = 'Please choose a contribution type',
}
